// Vendors
import React from 'react'
import { useParams } from 'react-router'
import { useTranslation } from 'react-i18next'

// Components
import { RecollectFormShow } from '../form/show'

// Styles
import { LayoutLoggedPageList } from 'layout/PrivatePageList'

import { PageMetaSetting } from './meta'

export const PageRecollectShowRecord = (): JSX.Element => {
  /*
  |-----------------------------------------------------------------------------
  | Constants
  |-----------------------------------------------------------------------------
  |
  |
  */

  const { t } = useTranslation('recollect')
  const { id } = useParams<{ id: string }>()
  const { endpoint, title } = PageMetaSetting

  /*
  |-----------------------------------------------------------------------------
  | Renders.
  |-----------------------------------------------------------------------------
  |
  |
  */

  return (
    <LayoutLoggedPageList title={t(title)}>
      <RecollectFormShow endpoint={endpoint} id={id} />
    </LayoutLoggedPageList>
  )
}
